<template>
  <section class="dashboard-backorders" aria-label="Back Orders" :aria-busy="loading">
    <div class="bo-heading">
      <feather-icon icon="ClockIcon" size="22" aria-hidden="true" />
      <div>
        <h5>Back Orders</h5>
        <small>Pedidos cuja última BO está em BACK ORDER</small>
      </div>
    </div>
    <div v-if="loading" class="bo-skeleton" role="status">
      <span class="sr-only">Carregando Back Orders…</span>
    </div>
    <div v-else-if="error" class="bo-result" role="alert">
      <span>Contagem indisponível.</span>
      <button type="button" class="btn btn-outline-primary btn-sm" @click="load">Tentar novamente</button>
    </div>
    <div v-else-if="count !== null" class="bo-result">
      <strong class="bo-count">{{ count.toLocaleString('pt-BR') }}</strong>
      <span v-if="count === 0">Nenhum pedido com última BO em BACK ORDER neste período.</span>
      <span v-else-if="percentage !== null">{{ percentage }}% dos pedidos do período</span>
      <span v-else>pedido{{ count === 1 ? '' : 's' }} no período</span>
    </div>
    <p v-else class="bo-help">A contagem será consultada após carregar o período.</p>
    <p class="bo-help">Cada pedido é contado uma vez, incluindo BO00. Versões de BO não são novas compras e não aumentam o valor comprado. Quantidades e valores pendentes não são inferidos.</p>
    <small v-if="period" class="bo-period">
      Período dos pedidos: {{ formatFilterDate(period.dataInicio) }} a {{ formatFilterDate(period.dataFim) }}.
    </small>
  </section>
</template>

<script>
import { countDashboardBackorders } from '@/services/dashboardBackorders.service';
import { formatFilterDate } from '@/views/dashboards/customerDashboardPeriod';

export default {
  name: 'DashboardBackorders',
  props: {
    period: { type: Object, default: null },
    clienteid: { type: [String, Number], default: '' },
    portal: { type: Boolean, default: false },
    totalOrders: { type: [Number, String], default: null },
    refreshKey: { type: Number, default: 0 },
  },
  data() {
    return { count: null, loading: false, error: false, requestId: 0 };
  },
  computed: {
    queryKey() {
      return JSON.stringify([this.period, this.clienteid, this.portal, this.refreshKey]);
    },
    percentage() {
      const total = Number(this.totalOrders);
      if (this.count === null || !Number.isFinite(total) || total <= 0 || this.count > total) return null;
      return (this.count / total * 100).toLocaleString('pt-BR', { maximumFractionDigits: 1 });
    },
  },
  watch: {
    queryKey: { immediate: true, handler: 'load' },
  },
  beforeDestroy() {
    this.requestId += 1;
  },
  methods: {
    formatFilterDate,
    async load() {
      const request = ++this.requestId;
      this.count = null;
      this.error = false;
      this.loading = false;
      if (!this.period) return;
      this.loading = true;
      try {
        const count = await countDashboardBackorders({
          period: { ...this.period }, clienteid: this.clienteid, portal: this.portal,
        });
        if (request === this.requestId) this.count = count;
      } catch (_) {
        if (request === this.requestId) this.error = true;
      } finally {
        if (request === this.requestId) this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.dashboard-backorders { padding: 1.25rem 1.5rem; margin-bottom: 1.5rem; border: 1px solid rgba(143, 222, 234, .4); border-radius: 12px; background: var(--sf-surface-bg, rgba(255, 255, 255, .85)); color: inherit; }
.bo-heading { display: flex; align-items: center; gap: .75rem; color: var(--primary, #0575b5); }
.bo-heading h5 { margin: 0 0 .25rem; color: inherit; font-weight: 700; }
.bo-result { display: flex; align-items: center; flex-wrap: wrap; gap: .75rem; margin: .75rem 0; }
.bo-count { font-size: 1.75rem; line-height: 1.1; }
.bo-help { font-size: .85rem; margin: .75rem 0 .25rem; }
.bo-period { display: block; }
.bo-skeleton { width: 7rem; height: 2rem; border-radius: 6px; margin: .75rem 0; background: rgba(143, 222, 234, .3); }
@media (max-width: 575.98px) { .dashboard-backorders { padding: 1rem; } }
</style>
